// AdminDataType enum'unu tanımlamanız gerekebilir
export enum UserType {
  Admin = 1,
  Editor = 2
}
